import {Component} from '@angular/core';
import {ApiClientService} from '../../../services/api-client.service';
import {DirectoryService} from '../../../services/directory.service';
import { AuthenticationService } from '../../../services/authentication.service';
import {StripeAccountsService} from '../../../services/stripe-accounts.service';
import {UrlService} from '../../../services/url.service';

declare const toastr: any;
declare const moment: any;

@Component({
    selector: 'stripe-accounts-detailed-view',
    templateUrl: './stripe-accounts-detailed-view.component.html',
    styleUrls: ['./stripe-accounts-detailed-view.component.scss']
})

export class StripeAccountsDetailedViewComponent {
    payOutDisabled = false;
    descriptionEditMode = false;
    description = '';
    copyBeforeEdit = '';

    constructor(
        public api: ApiClientService,
        public urlService: UrlService,
        public stripeAccountsService: StripeAccountsService,
        public directoryService: DirectoryService,
        public authenticationService: AuthenticationService
    ) {}

    getPayOutSum() {
        return this.stripeAccountsService.selectedItems.reduce((total, item) => total + item.net, 0);
    }

    payOut() {
        this.payOutDisabled = true;
        const corporationId = this.stripeAccountsService.selectedStripeAccountId;
        const url = `/v1/stripe_payout/${corporationId}.json`;
        const data = {
            stripePayments: this.stripeAccountsService.selectedItems.map(item => (item.id)),
            description: !this.description ? this.getDefaultDescription() : this.description
        };
        this.api.post('domainAmenities', url, data).subscribe(
            res => {
                toastr.success('Pay Out has been successful');
                this.stripeAccountsService.getStripeBalance();
                this.stripeAccountsService.toggleDetailedView(null, false);
                this.urlService.setQueryParams('allStripePayouts');
            },
            error => {
                this.payOutDisabled = false;
                this.api.errorHandler('Pay Out failed', error);
            }
        );
    }

    getDefaultDescription() {
        let min = this.stripeAccountsService.selectedItems[0].createdAt;
        let max = this.stripeAccountsService.selectedItems[0].createdAt;

        this.stripeAccountsService.selectedItems.forEach(
            i => {
                if(i.createdAt < min)
                    min = i.createdAt;

                if(i.createdAt > max)
                    max = i.createdAt;
            }
        );

        return `Pay Out ${moment(min).format('YYYY-MM-DD')} - ${moment(max).format('YYYY-MM-DD')}`;
    }

    turnEditMode(turn) {
        if(turn) {
            if(this.descriptionEditMode)
                return;

            this.copyBeforeEdit = this.description;
            this.descriptionEditMode = true;
            if(!this.description)
                this.description = this.getDefaultDescription();
        } else {
            this.copyBeforeEdit = '';
            this.descriptionEditMode = false;
            if(!this.description)
                this.description = '';
        }
    }

    cancelEdit() {
        this.description = this.copyBeforeEdit;
        this.descriptionEditMode = false;
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/stripe-accounts/stripe-accounts-detailed-view/stripe-accounts-detailed-view.component.ts